import { render, staticRenderFns } from "./panel_wait.vue?vue&type=template&id=d5e16992&scoped=true&"
import script from "./panel_wait.vue?vue&type=script&lang=js&"
export * from "./panel_wait.vue?vue&type=script&lang=js&"
import style0 from "./panel_wait.vue?vue&type=style&index=0&id=d5e16992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e16992",
  null
  
)

export default component.exports